module.exports = __webpack_public_path__ + "img/italy-cerebrovascular-disease-female.d7b94665.png";